export const asideBulk = {
    back: {
        title: "Retournez vers la boutique",
        label: "Retour à la boutique"
    }
}
